<template>
  <div ref="element">
    <slot></slot>
  </div>
</template>

<script>
import anime from "animejs/lib/anime.es.js";
export default {
  name: "Translot",
  methods: {
    animate() {
      anime({
        targets: this.$refs.element,
        opacity: [0, 1],
        duration: 5000,
      });
    },
  },
  mounted() {
    this.animate();
  },
};
</script>

<style scoped>
</style>